import {Button, Space} from 'antd';
import {Auth} from 'aws-amplify';
import {AnchorLink} from 'components/AnchorLink';
import {ModalContent, ModalFooter} from 'components/EnableSmsMFA/Shared';
import {FormItem} from 'components/Form';
import {Formik} from 'formik';
import {Form, Input, SubmitButton} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {useAsyncAction} from 'hooks/useAsyncAction';
import {formatPhone} from 'lib/formaters';
import React from 'react';
import * as yup from 'yup';

export type ConfirmFormValues = {
  code: string;
};

type Props = {
  phoneNumber: string;
  onSubmit: (values: ConfirmFormValues) => Promise<void>;
  onCancel: () => void;
};

export const Confirm: React.FC<Props> = ({onSubmit, onCancel, phoneNumber}) => {
  const schema = yup.object().shape({
    code: yup.string().required()
  });

  const formattedPhoneNumber = formatPhone(phoneNumber);

  const handleSubmit = async (
    values: ConfirmFormValues,
    {setSubmitting, setErrors}: FormikHelpers<ConfirmFormValues>
  ) => {
    try {
      await onSubmit(values);
    } catch (error: any) {
      setSubmitting(false);
      setErrors({code: error.message});
    }
  };

  const handleResend = async () => {
    const user = await Auth.currentAuthenticatedUser();
    await Auth.verifyUserAttribute(user, 'phone_number');
  };

  const [resend, isResending] = useAsyncAction(handleResend);

  return (
    <>
      <Formik onSubmit={handleSubmit} initialValues={{code: ''}} validationSchema={schema}>
        <Form layout="vertical">
          <ModalContent>
            <p>
              Enter the 6-digit code we sent to <strong>{formattedPhoneNumber}</strong>. Didn't
              receive a code?{' '}
              <AnchorLink onClick={resend} disabled={isResending}>
                Resend
              </AnchorLink>
              .
            </p>
            <FormItem name="code">
              <Input name="code" placeholder="Verification code" />
            </FormItem>
          </ModalContent>
          <ModalFooter>
            <Space>
              <Button onClick={onCancel}>Cancel</Button>
              <SubmitButton disabled={false}>Confirm</SubmitButton>
            </Space>
          </ModalFooter>
        </Form>
      </Formik>
    </>
  );
};
